import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c3368ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-async-test" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-base font-bold" }
const _hoisted_7 = { class: "text-sm desc" }
const _hoisted_8 = { class: "text-xs text-grey desc" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-base font-bold" }
const _hoisted_12 = { class: "text-sm desc" }
const _hoisted_13 = { class: "text-xs text-grey desc" }

import {
  ref,
  toRefs,
  computed,
  watch,
  withDefaults
} from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import
vSelect,
{
  VueSelectProps
} from 'vue-select'
import { useIntersectionObserver } from '@vueuse/core'
import moment from 'moment'

interface IPropsSelectAsync extends Partial<VueSelectProps> {
  endpoint: string
  fieldValue?: string
  fieldLabel?: (item: any) => string
  searchFields?: Array<string>
  modelValue?: any
  searchCustom?: Array<any>
  id?: string
  classname?: string
  selectable?: (item: any) => boolean
  inputId: string
  placeholder: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAsyncTest',
  props: {
    endpoint: { default: '' },
    fieldValue: { default: 'Id' },
    fieldLabel: { type: Function, default: () => 'Name' },
    searchFields: { default: () => [] },
    modelValue: { default: null },
    searchCustom: { default: () => [] },
    id: { default: '' },
    classname: { default: '' },
    selectable: { type: Function, default: () => true },
    inputId: { default: '' },
    placeholder: { default: 'Pilih' }
  },
  emits: ["update:modelValue", "change", "search:focus"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', val: any): void
  (e: 'change', val: any): void
  (e: 'search:focus'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { endpoint: string, fieldValue: string, fieldLabel: (item: any) => string, searchFields: Array<string>, modelValue: any, searchCustom: Array<any>, id: string, classname: string, selectable: (item: any) => boolean, inputId: string, placeholder: string }





const {
  endpoint,
  fieldLabel,
  modelValue,
  inputId,
  placeholder,
  clearable,
  disabled,
  fieldValue,
  searchFields,
  searchCustom,
  id,
  selectable,
  classname
} = toRefs(props)

const isLoading = ref(false)
const options = ref([]) as any
const inputSearch = ref('')

const valueSelect = computed({
  get: () => modelValue?.value,
  set: (v) => {
    emit('update:modelValue', v)
  }
})
const hasNextPage = ref(false)
const load = ref(null) as unknown as HTMLElement
const targetIsVisible = ref(false)
const pagination = {
  count: 0,
  pageNumber: 1,
  pageSize: 10,
  limit: 0
}

const selectableRow = (row: any) => selectable?.value(row)

// eslint-disable-next-line consistent-return
// const selectableRule = (val: any) => {
//   console.log('vall=>', val)
//   if (selectableParams.value.length > 0) {
//     if (lowerCase(selectableParams.value[1]) === 'equal') {
//       if (val[`${selectableParams.value[0]}`] === selectableParams.value[2]) {
//         return true
//       }
//       return false
//     }
//     if (lowerCase(selectableParams.value[1]) === 'notequal') {
//       if (val[`${selectableParams.value[0]}`] !== selectableParams.value[2]) {
//         return true
//       }
//       return false
//     }
//   }
//   return true
// }

const getData = async () => {
  try {
    isLoading.value = true
    const { result, error, count, pagenumber } = await apiUseCase.get(`${endpoint.value}${returnUrlPrams({
      search: inputSearch.value,
      filterField: searchFields.value,
      custom: searchCustom.value,
      pageNumber: pagination.pageNumber
    })}`)
    if (!error) {
      if (pagenumber === 1) {
        pagination.limit = 0
        pagination.count = 0
        options.value = []
        // console.log('optionsreset', [inputSearch.value, options.value])
      }
      pagination.limit = count
      pagination.count += result.length
      // console.log([pagination.limit, pagination.count])
      if (pagination.count < pagination.limit) {
        hasNextPage.value = true
        pagination.pageNumber += 1
      } else {
        hasNextPage.value = false
      }

      // console.log('asadad', hasNextPage.value)
      // eslint-disable-next-line array-callback-return
      result.map((item: any) => {
        const data = {
          ...item,
          label: typeof fieldLabel.value === 'function' ? fieldLabel.value(item) : item[fieldLabel.value],
          value: item[fieldValue.value]
        }
        options.value.push(data)
      })
      console.log('options', options.value)
    }
    isLoading.value = false
  } catch (err) {
    isLoading.value = false
  }
}

const onOpen = () => {
  if (pagination.count === 0) {
    getData()
  }
  emit('search:focus')
}

const onSearch = (val: any) => {
  // console.log('valSearch', val)
  if (val !== inputSearch.value) {
    pagination.pageNumber = 1
    options.value = []
    hasNextPage.value = false
    inputSearch.value = val
    getData()
  }
}

const { stop } = useIntersectionObserver(load, ([{ isIntersecting }], observerElement) => {
  targetIsVisible.value = isIntersecting

  const documentId = document.querySelector('#load') as HTMLElement

  const ul = documentId.offsetParent as any
  const xxxx = documentId.offsetParent?.scrollTop
  ul.scrollTop = xxxx
  // console.log('xxx', [xxxx, ul])
  if (targetIsVisible.value) {
    // pagination.pageNumber += 1
    // searchCustom.value = []
    // searchCustom.value.push(['pageNumber', '=', pagination.pageNumber])
    getData()
  }
})

// const onSearch = debounce(getData, 500)

const optionSelected = (select: any) => {
  // console.log('selec', select)
  emit('change', select)
}

watch(valueSelect, (val: any) => {
  console.log('val', val)
  if (!val) {
    emit('change', val)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(vSelect), {
      class: _normalizeClass(`select-default ${_unref(classname)}`),
      inputId: _unref(inputId),
      placeholder: _unref(placeholder),
      clearable: _unref(clearable),
      id: _unref(id),
      disabled: _unref(disabled),
      options: _unref(options),
      modelValue: _unref(valueSelect),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(valueSelect) ? (valueSelect).value = $event : null)),
      onOpen: onOpen,
      onSearch: onSearch,
      selectable: selectableRow,
      "onOption:selected": optionSelected,
      "onOption:deselecting": optionSelected,
      loading: isLoading.value,
      autofocus: false
    }, {
      "list-footer": _withCtx(() => [
        (hasNextPage.value)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              ref_key: "load",
              ref: load,
              id: "load",
              class: "loader"
            }, " Sedang memuat... ", 512))
          : _createCommentVNode("", true)
      ]),
      "no-options": _withCtx(({ searching, loading }) => [
        searching
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Tidak ada data ditemukan. "))
          : _createCommentVNode("", true),
        loading
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Tidak ada data ditemukan. "))
          : _createCommentVNode("", true)
      ]),
      "selected-option": _withCtx(({ Name, Code, IsTol, StartDate, EndDate }) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require(IsTol ? '@/assets/img/icon/toll-blue-fill.svg' : '@/assets/img/icon/toll-blue-fill-with-cross.svg'),
            alt: "toll"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, _toDisplayString(Name), 1)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(Code), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(`${_unref(moment)(StartDate).format('DD/MM/YYYY')} - ${_unref(moment)(EndDate).format('DD/MM/YYYY')}`), 1)
      ]),
      option: _withCtx(({ Name, Code, IsTol, StartDate, EndDate }) => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: require(IsTol ? '@/assets/img/icon/toll-blue-fill.svg' : '@/assets/img/icon/toll-blue-fill-with-cross.svg'),
            alt: "toll"
          }, null, 8, _hoisted_10),
          _createElementVNode("div", _hoisted_11, _toDisplayString(Name), 1)
        ]),
        _createElementVNode("p", _hoisted_12, _toDisplayString(Code), 1),
        _createElementVNode("p", _hoisted_13, _toDisplayString(`${_unref(moment)(StartDate).format('DD/MM/YYYY')} - ${_unref(moment)(EndDate).format('DD/MM/YYYY')}`), 1)
      ]),
      _: 1
    }, 8, ["class", "inputId", "placeholder", "clearable", "id", "disabled", "options", "modelValue", "loading"])
  ]))
}
}

})